export enum ControlType {
  INPUT = 1,
  SELECT = 2,
  CHECKBOX = 3,
  RADIOBUTTON = 4,
  PILL = 5,
  TEXTAREA = 6,
  MULTISELECT = 7,
  DATE = 8,
  TOGGLE = 9,
  DATERANGE = 10,
  INCREMENTING = 11,
  READONLY = 12,
  LABEL = 13,
  ACTION_BUTTON = 14,
  DESIGN_LABEL = 15,
  CUST_INPUT = 16,
  STATE_SELECT = 17,
  SBRA_DROPDOWN = 18,
  CLIMATE_ZONE = 19,
  TEXT = 20,
  BANNER = 21,
  LABELED_INCREMENTING = 22,
  VERSION_PILL = 23,
}
